class PlaybookFilterHandler {
	constructor(filters, search, sort, rules) {
		this.filters = filters;
		this.search = search;
		this.rules = rules;
		this.sort = sort;
	}

	/**
	 * Is Filtering
	 *
	 * @returns {boolean} Are playbooks currently being filtered?
	 */
	isFiltering() {
		return ['categories', 'goals', 'tags'].some((filter) => {
			return 0 !== this.filters[filter].length;
		});
	}

	/**
	 * Is Searching
	 *
	 * @returns {boolean} Are playbooks currently being searched?
	 */
	isSearching() {
		return '' !== this.search;
	}

	/**
	 * Is Sorting
	 *
	 * @returns {boolean} Are playbooks currently being searched?
	 */
	isSorting() {
		return '' !== this.sort;
	}

	/**
	 * Get Rule By Slug
	 *
	 * @param {string} slug The rule's slug.
	 *
	 * @returns {Object} The rule object.
	 */
	getRuleBySlug(slug) {
		const ruleObject = this.rules.filter((rule) => {
			return rule.id === slug;
		});

		return ruleObject[0] || null;
	}

	/**
	 * Rule Search String
	 *
	 * @param {Object} playbook The playbook object.
	 *
	 * @returns {string} The combined search string.
	 */
	ruleSearchString(playbook) {
		let combined = '';

		playbook.rules.forEach((slug) => {
			const rule = this.getRuleBySlug(slug);

			combined += rule ? `${rule.friendlyText} ` : '';
		});

		return combined.trim();
	}

	/**
	 * Should Include
	 *
	 * @param {Object} playbook The playbook object.
	 *
	 * @returns {boolean} Should the playbook be included?
	 */
	shouldInclude(playbook) {
		if (this.isSearching()) {
			const searchString = this.search.toLowerCase();

			// Commenting out the ability to search the Playbook name instead of removing completely
			// so we can add it back at a later date if we need to.
			// const name = playbook.name ? playbook.name.toLowerCase() : '';
			const description = playbook.playbook_description ? playbook.playbook_description.toLowerCase() : '';
			const inspiredBy = playbook.inspired_by ? playbook.inspired_by.toLowerCase() : '';
			const rules = this.ruleSearchString(playbook).toLowerCase();

			if (
				// !name.includes(searchString) &&
				!description.includes(searchString) &&
				!inspiredBy.includes(searchString) &&
				!rules.includes(searchString)
			) {
				return false;
			}
		}

		if (this.isFiltering()) {
			const passes = {
				categories: true,
				goals: true,
				tags: true,
			};

			Object.keys(passes).forEach((f) => {
				const currentFilter = this.filters[f];
				const currentCount = currentFilter.length;

				if (0 !== currentCount) {
					const playbookCategory = playbook[f];

					const found = playbookCategory.filter((p) => {
						return currentFilter.includes(p.id);
					});

					if (found.length !== currentFilter.length) {
						passes[f] = false;
					}
				}
			});

			if (!passes.categories || !passes.goals || !passes.tags) {
				return false;
			}
		}

		if (this.isSorting()) {
			if ('featured' === this.sort) {
				return playbook.tags.some((t) => {
					return 'Featured' === t.name;
				});
			}
		}

		return true;
	}
}

export default PlaybookFilterHandler;
